var map = {
	"./img/andalucia/teaser_small.jpg": 79012,
	"./img/basque-country/teaser_small.jpg": 63430,
	"./img/berlin/teaser_small.jpg": 92255,
	"./img/copenhagen/teaser_small.jpg": 18030,
	"./img/portugal/teaser_small.jpg": 76019,
	"./img/slovenia/teaser_small.jpg": 11105,
	"./img/turkey/teaser_small.jpg": 64575
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13617;